import React from "react";
import { Container } from "react-bootstrap";
import Header from "../Includes/Header";
import Footer from "../Includes/Footer";
import "../../App.css";

const UserAgreement: React.FC = () => {
  return (
    <>
      <Header />
      <Container className="py-5 mt-4" style={{ maxWidth: 820 }}>
        <h1 className="fw-bold mb-1">User Agreement</h1>
        <p className="text-secondary small mb-1">Last updated: August 2026</p>
        <p className="text-secondary small mb-5" style={{ lineHeight: 1.7 }}>
          ARM Financial Services Pty Ltd ("ARMF", "we", "us", or "our") · ABN 35 659 595 570 · ACN 659 595 570
          <br />
          Registered with AUSTRAC to provide remittance services in Australia (AAN 100812026, Registered Entity No. 75630)
          <br />
          Suite 110, Level 1, 530 Little Collins Street, Melbourne VIC 3000, Australia
        </p>

        <Section title="1. Purpose of This Agreement">
          This User Agreement applies specifically to business (entity) accounts opened with
          ARMF. It supplements, and should be read together with, our{" "}
          <a href="/terms-of-service">Terms of Service</a>,{" "}
          <a href="/privacy-policy">Privacy Policy</a>, and{" "}
          <a href="/acceptable-use-policy">Acceptable Use Policy</a>. Where this Agreement and
          the Terms of Service conflict on a matter specific to entity accounts, this Agreement
          governs.
        </Section>

        <Section title="2. Authorised Representative Warranty">
          By completing entity onboarding, you warrant that you are an authorised representative
          of the legal entity applying for an ARMF account, that you have the authority to bind
          that entity to this Agreement and our other terms, and that all information you provide
          about the entity, its directors, and its beneficial owners is true, current, and
          complete to the best of your knowledge.
        </Section>

        <Section title="3. Business Use Only">
          Entity accounts are provided for genuine business use by the registered legal entity.
          You agree not to use an entity account to transact on behalf of an undisclosed third
          party, or for personal transactions unrelated to the entity's business.
        </Section>

        <Section title="4. Keeping Your Information Current">
          Under the AML/CTF Act 2006 (Cth), ARMF is required to keep customer identification
          information up to date. You agree to promptly notify us of any change to the entity's
          registered details, directors, authorised representatives, or beneficial owners
          (including anyone acquiring or ceasing to hold 25% or more ownership or control of the
          entity).
        </Section>

        <Section title="5. Account Suspension &amp; Termination">
          ARMF may suspend or terminate an entity account in the circumstances set out in Section
          10 of our <a href="/terms-of-service">Terms of Service</a>, including where entity
          information is found to be inaccurate, where required by law, or where we reasonably
          suspect the account is being used for a prohibited purpose under our{" "}
          <a href="/acceptable-use-policy">Acceptable Use Policy</a>.
        </Section>

        <Section title="6. Contact Us">
          If you have questions about this User Agreement, please contact us at{" "}
          <a href="mailto:support@armf.com">support@armf.com</a>.
        </Section>
      </Container>
      <Footer full={true} />
    </>
  );
};

const Section: React.FC<{ title: string; children: React.ReactNode }> = ({ title, children }) => (
  <div className="mb-4">
    <h5 className="fw-semibold mb-2">{title}</h5>
    <div className="text-secondary" style={{ lineHeight: 1.8 }}>{children}</div>
  </div>
);

export default UserAgreement;
